import React from 'react';
import { NavigateFunction } from 'react-router-dom';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';
import Actions from '@components/common/Actions';

import { dateFormattingWithSlash } from '@utils/date';

import { columnSizes } from '@constants/table';
import { viewAssetCardTooltipText } from '@components/routes/AdminPanel/AssetsList/constants';

import styles from '@components/common/Table/Table.module.scss';

export const getColumns = ({ navigate }: { navigate: NavigateFunction }) =>
	([
		{
			header: 'VERSION',
			accessorKey: 'version',
			cell: ({ getValue, row }: CellContext<any, any>) => {
				const value = getValue();
				const openAssetHistoryProfile = () => navigate(`${row.original?.id}`);

				return (
					<AdaptiveTableCell
						onDoubleClick={openAssetHistoryProfile}
						text={value}
					/>
				);
			},
		},
		{
			header: 'Updated date',
			accessorKey: 'createdAt',
			size: columnSizes.size190,
			cell: ({ getValue, row }: CellContext<any, any>) => {
				const updatedAt = getValue();
				const date = dateFormattingWithSlash(+updatedAt);
				const openAssetHistoryProfile = () => navigate(`${row.original?.id}`);

				return (
					<AdaptiveTableCell
						onDoubleClick={openAssetHistoryProfile}
						text={date}
					/>
				);
			},
		},
		{
			header: 'changed by',
			accessorKey: 'requesterName',
			cell: ({ row: { original: { changedBy, id } } }: CellContext<any, any>) => {
				const openAssetHistoryProfile = () => navigate(`${id}`);

				return (
					<AdaptiveTableCell
						onDoubleClick={openAssetHistoryProfile}
						text={changedBy ? changedBy : ''}
					/>
				);
			},
		},
		{
			header: 'Changed fields',
			accessorKey: 'changedFields',
			enableSorting: false,
			cell: ({ getValue, row }: CellContext<any, any>) => {
				const value = getValue();
				const openAssetHistoryProfile = () => navigate(`${row.original?.id}`);

				return (
					<AdaptiveTableCell
						onDoubleClick={openAssetHistoryProfile}
						text={value}
					/>
				);
			},
		},
		{
			header: () => (
				<div className={styles.centerColumnHeader}>
					Actions
				</div>
			),
			accessorKey: 'actions',
			enableSorting: false,
			size: columnSizes.size90,
			cell: ({ row }: CellContext<any, any>) => {
				const openAssetHistoryProfile = () => navigate(`${row.original?.id}`);

				return (
					<Actions
						gridNumberOfColumns={1}
						isView
						viewHandler={openAssetHistoryProfile}
						viewTooltip={viewAssetCardTooltipText}
					/>
				);
			},
		},
	]);
